import { useEffect } from "react";
import { WHATSAPP_URL } from "@/lib/brand";

const AgendaRedirect = () => {
  useEffect(() => {
    // Redirige inmediatamente a WhatsApp con mensaje preescrito.
    window.location.replace(WHATSAPP_URL);
  }, []);

  return (
    <div
      data-testid="agenda-redirect"
      className="min-h-[60vh] flex items-center justify-center px-6 text-center"
    >
      <div>
        <p
          className="eyebrow"
          style={{ color: "var(--p-burgundy)" }}
        >
          Redirigiendo…
        </p>
        <h1
          className="mt-4"
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: "clamp(1.8rem, 3vw, 2.4rem)",
            fontWeight: 500,
            color: "var(--p-black)",
          }}
        >
          Abriendo WhatsApp para agendar tu cita…
        </h1>
        <p
          className="mt-3"
          style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)" }}
        >
          Si no se abre automáticamente,{" "}
          <a href={WHATSAPP_URL} style={{ color: "var(--p-burgundy)", textDecoration: "underline" }}>
            haz clic aquí
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default AgendaRedirect;
